var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { get } from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import { createVolumePromotions } from "../../classes/definitions/volumePromotion/volumePromotion";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import VolumePromotionsList from "../../components/VolumePromotions/VolumePromotionsList";
import AppRoutes from "../../config/appRoutes";
import SlidesReduxProps from "../Slides/SlidesReduxProps";
var VolumePromotions = /** @class */ (function (_super) {
    __extends(VolumePromotions, _super);
    function VolumePromotions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.brandId = '';
        _this.state = {
            data: [],
            meta: null
        };
        _this.queryParams = {
            page: 1,
        };
        _this.getAllVolumePromotions = function () {
            _this.api.getVolumePromotions(_this.queryParams)
                .then(function (response) {
                var volumePromotions = createVolumePromotions(response.data);
                var meta = get(response, "data.meta", null);
                _this.setState({ data: volumePromotions, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с всички промоции', _this.props.history);
            });
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            _this.api.deleteVolumePromotion(id)
                .then(function () { return _this.getAllVolumePromotions(); });
        };
        _this.editItem = function (id) {
            _this.props.history.push(AppRoutes.volumePromotion.path + "/" + id);
        };
        _this.onPage = function (page) {
            _this.queryParams.page = page;
            _this.getAllVolumePromotions();
        };
        _this.toNewItem = function () {
            _this.props.history.push(AppRoutes.volumePromotion.path);
        };
        _this.toImport = function () {
            _this.props.history.push(AppRoutes.volumePromotionsImport.path);
        };
        return _this;
    }
    VolumePromotions.prototype.componentDidMount = function () {
        this.getAllVolumePromotions();
    };
    VolumePromotions.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u0438 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("div", null,
                                React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewItem, type: "button" },
                                    React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                    " \u041D\u043E\u0432 \u0415\u043B\u0435\u043C\u0435\u043D\u0442"),
                                React.createElement("button", { className: "btn btn-sm btn-warning ml-2", onClick: this.toImport, type: "button" },
                                    React.createElement("i", { className: "fa fa-file-o" }),
                                    " \u0418\u043C\u043F\u043E\u0440\u0442"))),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(VolumePromotionsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem, meta: meta, editItem: this.editItem, onPage: this.onPage }))))));
    };
    return VolumePromotions;
}(React.Component));
export default connect(null, SlidesReduxProps.mapDispatchToProps)(VolumePromotions);



//////////////////
// WEBPACK FOOTER
// ./src/views/VolumePromotions/VolumePromotions.tsx
// module id = 518
// module chunks = 0